module.exports = __webpack_public_path__ + "static/img/promotion2_2.4355ec80.png";